import { RoleTypeEnum } from '../../enums/roleTypeEnum';

export class Role {
    constructor(roleType: RoleTypeEnum, isWriter: boolean, canEditGlobally: boolean) {
        this.roleType = roleType;
        this.isWriter = isWriter;
        this.canEditGlobally = canEditGlobally;
    }
    roleType: RoleTypeEnum;
    isWriter: boolean | null;
    canEditGlobally: boolean;
}
